import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { sanitizeHtml } from '@/lib/sanitize';
import Navbar from '@/components/Navbar';
import { Button } from '@/components/ui/button';
import { Loader2, ArrowLeft, AlertCircle } from 'lucide-react';

export default function CustomPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadPage();
  }, [slug]);

  const loadPage = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(`/pages/${slug}`);
      setPage(res.data);
    } catch (error) {
      setError('Página não encontrada');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <Navbar />
        <div className="flex items-center justify-center h-screen">
          <Loader2 className="w-8 h-8 animate-spin text-ruby" />
        </div>
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen bg-background">
        <Navbar />
        <main className="max-w-4xl mx-auto px-4 pt-24 pb-12">
          <div className="text-center py-20">
            <AlertCircle className="w-16 h-16 text-ruby mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-foreground mb-2">Página Não Encontrada</h1>
            <p className="text-muted-foreground mb-6">
              A página que procura não existe ou foi removida.
            </p>
            <Button onClick={() => navigate('/')} className="bg-ruby hover:bg-ruby-light">
              Voltar ao Início
            </Button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <main className="max-w-4xl mx-auto px-4 pt-24 pb-12">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-muted-foreground hover:text-white"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Voltar
        </Button>
        
        <article>
          <h1 className="text-4xl font-bold text-foreground mb-8">{page.title}</h1>
          
          <div 
            className="custom-page-content text-muted-foreground leading-relaxed space-y-4 [&>h2]:text-2xl [&>h2]:font-semibold [&>h2]:text-white [&>h2]:mt-8 [&>h2]:mb-4 [&>h3]:text-xl [&>h3]:font-medium [&>h3]:text-white [&>h3]:mt-6 [&>h3]:mb-3 [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:space-y-2 [&>ol]:list-decimal [&>ol]:pl-6 [&>ol]:space-y-2 [&>a]:text-ruby [&>a]:underline [&>a:hover]:text-ruby-light [&>blockquote]:border-l-4 [&>blockquote]:border-ruby [&>blockquote]:pl-4 [&>blockquote]:italic [&>blockquote]:text-muted-foreground"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.content) }}
          />
        </article>
      </main>
    </div>
  );
}
